import { Form } from "antd";
import { CategoriesResponseModel } from "api/repositories/categories/model/CategoriesResponseModel";
import { FieldsResponseModel } from "api/repositories/fields/model/FieldsResponseModel";
import { GoodsResponseModel } from "api/repositories/goods/model/GoodsResponseModel";
import { InventoryResponseModel } from "api/repositories/inventories/model/InventoryResponseModel";
import { PartnerResponseModel } from "api/repositories/partners/model/PartnerResponseModel";
import { StoragesResponseModel } from "api/repositories/storages/model/StoragesResponseModel";
import { UserFeatureResponseModel } from "api/repositories/users/model/feature/UserFeatureResponseModel";
import { UsersResponseModel } from "api/repositories/users/model/UsersResponseModel";
import { VariantsResponseModel } from "api/repositories/variants/model/VariantsResponseModel";
import { WalletsResponseModel } from "api/repositories/wallets/model/WalletsResponseModel";
import { SidebarConfigModel } from "api/sidebarConfig/model/SidebarConfigModel";
import { ReactNode, useState } from "react";
import { AuthenticationProps } from "./AuthenticationContext";

const GlobalVariablesList = () => {
  const [globalFilterForm] = Form?.useForm();
  const [globalActionForm] = Form?.useForm();
  const [globalImportForm] = Form?.useForm();
  const [importRequestForm] = Form.useForm();
  const [globalTemp, setGlobalTemp] = useState<unknown>();
  const [breadCrumb, setBreadCrumb] = useState<
    Array<{
      href: string;
      title: ReactNode | string;
    }>
  >([]);
  const [token, setToken] = useState<string | undefined>("");
  const [user, setUser] = useState<UsersResponseModel>({});
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState({});
  const [menuConfig, setMenuConfig] = useState<SidebarConfigModel>();
  const [variantsForFilter, setVariantsForFilter] = useState<
    VariantsResponseModel[]
  >([]);
  const [suppliersForFilter, setSuppliersForFilter] = useState<
    PartnerResponseModel[]
  >([]);
  const [categoriesForFilter, setCategoriesForFilter] = useState<
    CategoriesResponseModel[]
  >([]);
  const [storagesForFilter, setStoragesForFilter] = useState<
    StoragesResponseModel[]
  >([]);
  const [goodsForFilter, setGoodsForFilter] = useState<GoodsResponseModel[]>(
    []
  );
  const [inventoriesForFilter, setInventoriesForFilter] = useState<
    InventoryResponseModel[]
  >([]);

  const [fieldsForFilters, setFieldsForFilters] = useState<
    FieldsResponseModel[]
  >([]);

  const [walletForFilter, setWalletForFilter] = useState<
    WalletsResponseModel[]
  >([]);

  const [userFeature, setUserFeature] = useState<UserFeatureResponseModel[]>(
    []
  );
  const [userRole, setUserRole] = useState<string>("");
  const [excelLoading, setExcelLoading] = useState<{
    transaction: boolean;
    transactionWarehouse: boolean;
    generals: boolean;
    items: boolean;
    import: boolean;
    export: boolean;
    supplierImport: boolean;
    mSaleImport: boolean;
  }>({
    generals: false,
    items: false,
    transaction: false,
    transactionWarehouse: false,
    export: false,
    import: false,
    mSaleImport: false,
    supplierImport: false,
  });
  const [globalModal, setGlobalModal] = useState<
    AuthenticationProps["globalModal"]
  >({
    supplierImport: false,
  });
  const [stepProps, setStepProps] = useState({
    storage: false,
    supplier: false,
    goods: false,
  });
  const [activeImportStepProps, setActiveImportStepProps] = useState({
    storage: false,
    supplier: false,
    goods: false,
  });
  const [authReady, setAuthReady] = useState(false);

  return {
    globalFilterForm,
    globalActionForm,
    globalImportForm,
    globalTemp,
    setGlobalTemp,
    token,
    setToken,
    user,
    setUser,
    loading,
    setLoading,
    profile,
    setProfile,
    menuConfig,
    setMenuConfig,
    variantsForFilter,
    setVariantsForFilter,
    suppliersForFilter,
    setSuppliersForFilter,
    categoriesForFilter,
    setCategoriesForFilter,
    storagesForFilter,
    setStoragesForFilter,
    goodsForFilter,
    setGoodsForFilter,
    inventoriesForFilter,
    setInventoriesForFilter,
    fieldsForFilters,
    setFieldsForFilters,
    walletForFilter,
    setWalletForFilter,
    userFeature,
    setUserFeature,
    userRole,
    setUserRole,
    excelLoading,
    setExcelLoading,
    globalModal,
    setGlobalModal,
    stepProps,
    setStepProps,
    importRequestForm,
    activeImportStepProps,
    setActiveImportStepProps,
    breadCrumb,
    setBreadCrumb,
    authReady,
    setAuthReady,
  };
};

export default GlobalVariablesList;
